import { Estacion } from './Estacion';
import { ReporteMarcasProductos } from './ReporteMarcasProductos';

export class ReporteEstacionesMarcas {
    estacion:Estacion;
    productosPorMarca:ReporteMarcasProductos[];
}